.message {
  border: 1px solid var(--color-info-border);
  margin: 1rem;
  padding: 1rem;
}

.warning {
  background: var(--color-info);
  color: var(--color-info-fg);
}

.info {
  background: var(--color-info);
  border-color: var(--color-text);
}

.success {
  background: #d4edda;
  border-color: var(--color-positive);
  color: #155724;
}

/* A low, calm strip. */
.quiet {
  border: none;
  border-left: 3px solid var(--color-info-border);
  border-radius: 8px;
  font-size: var(--font-size-small);
  margin: 1rem 0 0;
  padding: 0.5rem 1rem;
}
